export const SCOPES = {
  INTEGRATIONS_MANAGEMENT_WRITE: 'integrations-management-write',
};
